import { useEffect, useMemo, useState } from 'react';

import DashboardHeader from './DashboardHeaderAdmin';
import DashboardCards from './DashboardCardsAdmin';
import DashboardGrid from './DashboardGridAdmin';
import './DasboardAdminCSS.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';



import { getDashboardData } from './api/dashboardApiAdmin';

const emptyValues = new Set(['', '0', 'no', 'false', 'na', 'n/a', 'nil', 'none', 'Not Available']);

const hasValue = (value) => {
  if (value === null || value === undefined) return false;
  const text = String(value).trim().toLowerCase();
  return !emptyValues.has(text);
};

const toNumber = (value) => {
  const number = Number(String(value ?? '').replace(/,/g, '').trim());
  return Number.isFinite(number) ? number : 0;
};

const sumField = (data, field) =>
  data.reduce((sum, row) => sum + toNumber(row[field]), 0);

function DashboardAdmin() {

  const [rowData, setRowData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const response = await getDashboardData();
    setRowData(response);
    setFilteredData(response);
  };

  const summary = useMemo(() => ({
    totalUlbs: filteredData.length,
    totalProperties: sumField(filteredData, 'total_properties_mis'),
    totalEnp: sumField(filteredData, 'no_of_enp_ids_available'),
    totalWater: sumField(filteredData, 'water_connection_id'),
    totalMobile: sumField(filteredData, 'mobile_no'),
    totalMunicipal: sumField(filteredData, 'municipal_connections')
  }), [filteredData]);

  // ================= INLINE STYLES =================
  const styles = {
    container: {
      padding: "20px",
      background: "#ebeef5",
      minHeight: "100vh",
      fontFamily: "Arial, sans-serif"
    },

    title: {
      fontSize: "22px",
      fontWeight: "800",
      color: "#050d1e",
      margin: "15px 0"
    },

    gridWrapper: {
      background: "#fff",
      padding: "15px",
      borderRadius: "15px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
    }
  };

  return (

      <div className="dashboard-admin-page" style={styles.container}>
      <DashboardHeader />
      <DashboardCards summary={summary} />
      <div style={styles.title}>
        GIS & MPHS Master Data Sheet
      </div>
      <div style={styles.gridWrapper}>
      <DashboardGrid
          rowData={rowData}
          setFilteredData={setFilteredData}
        />
      </div>
    </div>
  );
}

export default DashboardAdmin;
